module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_moradi_sm-fe9a6ae37b9e41f0a07d02d6f4b24709.png";